const material_terms_data = {
  title: `Material Terms Profiles`,
  body: `Select the Material Terms Profiles to add to Addendum C.`,
  table: {
    th: [
      "Section of Material Term or Condition",
      "Summary of Material Term or Condition",
      "Details of Material Term or Condition",
    ],
    td: [
      "material_terms_section_number",
      "material_terms_summary",
      "material_terms_details",
    ],
  },
  new_profile(profile) {
    return {
      id: profile.id,
      material_terms_section_number: profile.material_terms_section_number,
      material_terms_summary: profile.material_terms_summary,
      material_terms_details: profile.material_terms_details,
    };
  },
};

export default material_terms_data;
